export default __webpack_public_path__ + "static/media/Biodiesel70_30.2e3fe6a8.svg";